import { AppCard } from './AppCard';
import type { AppDefinition } from '../data/apps';

interface AppGridProps {
  apps: AppDefinition[];
  favoriteIds?: Set<string>;
  onToggleFavorite?: (appId: string) => void;
  /** When true, cards render as locked (not launchable) — request-access apps. */
  locked?: boolean;
}

/** 4-column responsive grid of AppCards with entrance stagger */
export function AppGrid({ apps, favoriteIds, onToggleFavorite, locked }: AppGridProps): React.JSX.Element {
  if (apps.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '48px 0', color: '#888', fontFamily: "'Lato', sans-serif" }}>
        <p style={{ fontSize: '16px', marginBottom: '8px' }}>No apps available</p>
        <p style={{ fontSize: '13px' }}>Visit the App Store to request access to applications.</p>
      </div>
    );
  }

  return (
    <div
      className="vx-grid-stagger"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '20px',
      }}
    >
      {apps.map(app => (
        <AppCard
          key={app.id}
          app={app}
          isFavorite={favoriteIds?.has(app.id)}
          onToggleFavorite={onToggleFavorite}
          locked={locked}
        />
      ))}

      {/* Responsive override via media query — handled in globals.css */}
    </div>
  );
}
